import * as Cookies from 'js-cookie';
import * as CryptoJS from 'crypto-js';
import { isLocal } from './isLocal';

type ValueProps = string | object;

interface AddProps {
  key: string;
  value: ValueProps;
  encrypt?: boolean;
  expires?: Date;
}

function getAllCookies(): { [key: string]: string } {
  const cookies: { [key: string]: string } = {};

  document.cookie.split(';').forEach((cookie) => {
    const [name, value] = cookie.split('=');
    const cookieName = name?.trim();
    const cookieValue = decodeURIComponent(value?.trim());
    cookies[cookieName] = cookieValue;
  });

  return cookies;
}

const checkCookie = (key: string): boolean => {
  return key in getAllCookies();
};

const getCookie = (
  key: string,
  decrypt?: boolean
): string | undefined => {
  const valueEncoded = Cookies.get(key);
  return decrypt && valueEncoded ? CryptoJS.enc.Base64.parse(valueEncoded).toString() : valueEncoded;
};

const addCookie = ({ key, value, encrypt, expires }: AddProps): void => {
  const currentValue =
    typeof value === 'object' ? JSON.stringify(value) : value;
  const encodedWord = CryptoJS.enc.Utf8.parse(currentValue);
  const valueEncoded = encrypt
    ? CryptoJS.enc.Base64.stringify(encodedWord)
    : currentValue;

  Cookies.set(key, valueEncoded, {
    expires,
    domain: isLocal() ? 'localhost' : 'acordocerto.com.br'
  });
};

const removeCookie = (key: string): void => {
  Cookies.remove(key, {
    domain: isLocal() ? 'localhost' : 'acordocerto.com.br'
  });
};

const removeWithKeyIncludes = (partialKey: string): void => {
  Object.keys(getAllCookies()).forEach((key) => {
    if (key.includes(partialKey)) {
      removeCookie(key);
    }
  });
};

export default {
  addCookie,
  checkCookie,
  getAllCookies,
  getCookie,
  removeCookie,
  removeWithKeyIncludes,
}
